import React from "react";

const TableStyle = () => {

return (

<style>

{`

/* ===============================
   TABLE HEADER DARK MAROON
================================ */

.ant-table-thead > tr > th{

background:#311701 !important;

color:#ffffff !important;

font-weight:700;

font-size:14px;

border-color:#5a2a0a !important;

}


/* HEADER HOVER */

.ant-table-thead > tr:hover > th{

background:#311701 !important;

color:#ffffff !important;

}


/* SORT ICON */

.ant-table-thead > tr > th .ant-table-column-sorter{

color:#ffffff !important;

}


/* FILTER ICON */

.ant-table-thead > tr > th .ant-table-filter-trigger{

color:#ffffff !important;

}


/* ===============================
   TABLE ROW HOVER LIGHT MAROON
================================ */

.ant-table-tbody > tr.student-row:hover > td{

background:#f1d6d6 !important;

transition:all .35s ease !important;

}


/* FIXED LEFT / RIGHT COLUMNS */

.ant-table-tbody > tr.student-row:hover > td.ant-table-cell-fix-left,
.ant-table-tbody > tr.student-row:hover > td.ant-table-cell-fix-right{

background:#f1d6d6 !important;

}


/* BODY CELL TRANSITION */

.ant-table-tbody > tr.student-row > td{

transition:all .35s ease;

}


/* ===============================
   DARK MODE
================================ */

.dark-mode .ant-table-tbody > tr.student-row:hover > td{

background:rgba(238,165,7,.18)!important;

}


/* ===============================
   BUTTON ANIMATION
================================ */

.secure-btn{

transition:.3s ease!important;

}


.secure-btn:hover{

transform:translateY(-3px);

box-shadow:0 8px 20px rgba(238,165,7,.35);

}


`}

</style>

);

};


export default TableStyle;